/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { InformativePaDetail } from "./InformativePaDetail";
import { BinaryFile } from "./BinaryFile";
import { Pa } from "./Pa";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const InformativePaMasterR = t.interface({});

// optional attributes
const InformativePaMasterO = t.partial({
  dataInizioValidita: UTCISODateFromString,

  dataPubblicazione: UTCISODateFromString,

  fkBinaryFile: BinaryFile,

  id: t.Integer,

  idInformativaPa: t.string,

  pagamentiPressoPsp: t.boolean,

  versione: t.string
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type InformativePaMaster = t.TypeOf<typeof InformativePaMasterR> &
  t.TypeOf<typeof InformativePaMasterO> & {
  readonly "details"?: ReadonlyArray<InformativePaDetail>;
  readonly "fkPa"?: Pa;
  };

export const InformativePaMaster: t.Type<InformativePaMaster> = t.recursion("InformativePaMaster", () =>
  t.intersection(
    [InformativePaMasterR, t.partial({ ...InformativePaMasterO.props, "details": t.readonlyArray(InformativePaDetail, "array of InformativePaDetail"), "fkPa": Pa })],
    "InformativePaMaster"
  ) as unknown as t.Type<InformativePaMaster>
);
